import React from 'react';
import Image from 'next/image';
import { FaCheckCircle } from 'react-icons/fa';
import { ServiceCardProps } from '../types';

const ServiceCard: React.FC<ServiceCardProps> = ({ img, title, description, items, reverse = false }) => {
  const renderItems = () => {
    if (!items || !Array.isArray(items)) return null;

    return items.map((item, index) => (
      <li key={index} className="flex items-start space-x-2 text-gray-medium mb-2">
        <FaCheckCircle className="text-green-accent mt-1" />
        <span>{item.trim()}</span>
      </li>
    ));
  };

  return (
    <div className={`flex flex-col ${reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} justify-between items-center mb-8`}>
      <div className="w-full lg:w-2/5 relative"> {/* Agregado relative para posicionar la sombra */}
        <Image
          src={img}
          alt="img"
          className="shadow-[20px_20px_0px_0px_var(--green-light)] rounded-lg transform transition-transform duration-500 hover:scale-105"
        />
      </div>
      <div className="w-full lg:w-2/4 space-y-5 mt-5 lg:mt-0 text-center lg:text-left"> {/* Agregado mt-5 para espacio en mobile */}
        <h2 className="text-3xl md:text-4xl font-semibold">{title}</h2> {/* Ajustado tamaño de fuente para mobile */}
        <p className="text-gray-medium">{description}</p>
        <p className="text-gray-medium">Sicons Perú brinda lo siguiente:</p>
        <ul className="list-none ml-0">
          {renderItems()}
        </ul>
      </div>
    </div>
  );
};

export default ServiceCard;
